import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { local_words_set_word_for_adding_related } from '@/state/words/local_words_set_word_for_adding_related_words';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { use_dispatch } from '../_base/use_dispatch';
import { use_effect } from '../_base/use_effect';
import { useToast } from '../use-toast';

export function use_toast_related_words_created(word_english: string) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const dispatch = use_dispatch();

  const { toast, dismiss } = useToast();

  const [toast_id, set_toast_id] = useState('');

  /*
   * EFFECTS
   */

  use_effect(() => {
    return () => dismiss(toast_id);
  }, [toast_id]);

  /*
   * EVENTS
   */
  function on_button_show_related_words_clicked(toast_id: string) {
    dismiss(toast_id);

    set_toast_id('');

    dispatch(local_words_set_word_for_adding_related(word_english));
  }

  /*
   * METHODS
   */

  function show() {
    let toast_data = toast({
      title: t(i18n_base_ui.toasts.related_words_created.title),
      description: t(i18n_base_ui.toasts.related_words_created.description, { word_english }),
      action: (
        <UI_PRIMITIVE__button variant="outline-on-bar" onClick={() => on_button_show_related_words_clicked(toast_data.id)}>
          {t(i18n_base_ui.toasts.related_words_created.actions.button.show_related_words)}
        </UI_PRIMITIVE__button>
      ),
    });

    set_toast_id(toast_data.id);
  }

  return { show };
}
